module.exports = __webpack_public_path__ + "static/footer-logo-f47bd5f9af870aa24ccfb7d8ff7d8364.png";